module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.includeNewButton && _vm.editable) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": _vm.newTask
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Task")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      staticClass: "panel panel-default task"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "task-controls"
    }, [(_vm.editable) ? _c('div', [_c('button', {
      staticClass: "btn btn-default btn-sm",
      staticStyle: {
        "position": "absolute",
        "top": "5px",
        "right": "5px"
      },
      attrs: {
        "title": "Edit Task"
      },
      on: {
        "click": function($event) {
          _vm.editTask(task)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.toggleTaskCompletion(task)
        }
      }
    }, [(!task.completed_at) ? _c('span', [_c('i', {
      staticClass: "fa fa-square-o"
    }), _vm._v("\n\t\t\t\t\t\t\tMark as Done\n\t\t\t\t\t\t")]) : _c('span', [_c('i', {
      staticClass: "fa fa-check-square-o"
    }), _vm._v("\n\t\t\t\t\t\t\tMark as Incomplete\n\t\t\t\t\t\t")])]), _vm._v(" "), (task.billable == 1) ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (task.billed),
        expression: "task.billed"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": 1,
        "false-value": 0
      },
      domProps: {
        "checked": Array.isArray(task.billed) ? _vm._i(task.billed, null) > -1 : _vm._q(task.billed, 1)
      },
      on: {
        "change": function($event) {
          _vm.toggleTaskBilled(task)
        },
        "__c": function($event) {
          var $$a = task.billed,
            $$el = $event.target,
            $$c = $$el.checked ? (1) : (0);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (task.billed = $$a.concat($$v))
            } else {
              $$i > -1 && (task.billed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            task.billed = $$c
          }
        }
      }
    }), _vm._v(" Task is Billed\n\t\t\t\t\t\t")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "task-description"
    }, [(task.priority == 2) ? _c('i', {
      staticClass: "fa fa-exclamation important-icon"
    }) : _vm._e(), _vm._v(" "), (_vm.showOwner && task.owner) ? _c('h4', [_vm._v(_vm._s(task.owner_type == 'client' ? task.owner.company : task.owner.project_name) + " "), _c('small', [_vm._v(_vm._s(task.owner_type.toUpperCase()))])]) : _vm._e(), _vm._v("\n\t\t\t\t" + _vm._s(task.description) + "\n\t\t\t\t"), (!task.is_complete) ? _c('div', {
      staticClass: "task-meta"
    }, [(task.due_date) ? _c('div', {
      staticClass: "due-date"
    }, [_vm._v("Due " + _vm._s(_vm.formatDate(task.due_date, 'long')))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "assigned-to"
    }, [_vm._v("Assigned to " + _vm._s(task.assigned_to_user.first_name) + " " + _vm._s(task.assigned_to_user.last_name))])]) : _c('div', {
      staticClass: "task-meta"
    }, [_c('div', {
      staticClass: "completed-date"
    }, [_vm._v("Completed " + _vm._s(_vm.formatDate(task.completed_at, 'long, minutes')))]), _vm._v(" "), _c('div', {
      staticClass: "assigned-to"
    }, [_vm._v("Completed By " + _vm._s(task.completed_by_user.first_name) + " " + _vm._s(task.completed_by_user.last_name))])])])])])
  }), _vm._v(" "), (_vm.taskDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": "Edit Task",
      "modal-visible": _vm.taskDialog.visible,
      "confirm-button-text": "Save",
      "button-class": "btn-primary"
    },
    on: {
      "confirm": function($event) {
        _vm.saveTask(_vm.taskDialog.values)
      },
      "closeModal": function($event) {
        _vm.taskDialog.visible = false
      }
    }
  }, [_c('form-group', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "",
      "col-class": "col-md-0"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.description),
      expression: "taskDialog.values.description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-height": "100px"
    },
    attrs: {
      "placeholder": "Task Description"
    },
    domProps: {
      "value": (_vm.taskDialog.values.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskDialog.values.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Due Date",
      "col-class": "col-md-3"
    }
  }, [_c('date-field', {
    model: {
      value: (_vm.taskDialog.values.due_date),
      callback: function($$v) {
        _vm.taskDialog.values.due_date = $$v
      },
      expression: "taskDialog.values.due_date"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Priority",
      "col-class": "col-md-3"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.priority),
      expression: "taskDialog.values.priority"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taskDialog.values.priority = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Low")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("High")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Assigned To",
      "col-class": "col-md-3"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.assigned_to),
      expression: "taskDialog.values.assigned_to"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taskDialog.values.assigned_to = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$root.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.first_name) + " " + _vm._s(user.last_name))])
  }))]), _vm._v(" "), (_vm.ownerType != 'client' && _vm.ownerType != 'project') ? _c('form-group', {
    attrs: {
      "label": "Project/Client",
      "col-class": "col-md-3"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.owner_type),
      expression: "taskDialog.values.owner_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taskDialog.values.owner_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('optgroup', {
    attrs: {
      "label": "Clients"
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": 'client-' + client.id
      }
    }, [_vm._v(_vm._s(client.company))])
  })), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Projects"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": 'project-' + project.id
      }
    }, [_vm._v(_vm._s(project.project_name))])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.billable),
      expression: "taskDialog.values.billable"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.taskDialog.values.billable) ? _vm._i(_vm.taskDialog.values.billable, null) > -1 : _vm._q(_vm.taskDialog.values.billable, 1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.taskDialog.values.billable,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.taskDialog.values.billable = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.taskDialog.values.billable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.taskDialog.values.billable = $$c
        }
      }
    }
  }), _vm._v("\n        \t\tTask is Billable\n        \t")])]), _vm._v(" "), (_vm.taskDialog.values.billable == 1) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form-group', {
    attrs: {
      "label": "Price",
      "col-class": "col-md-1"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.price),
      expression: "taskDialog.values.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "title": "Amount",
      "placeholder": "Price 0.00"
    },
    domProps: {
      "value": (_vm.taskDialog.values.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskDialog.values.price = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_vm._v("Price Before Tax")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "24%",
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.tax),
      expression: "taskDialog.values.tax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "title": "Tax",
      "placeholder": "Tax 0.00"
    },
    domProps: {
      "value": (_vm.taskDialog.values.tax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskDialog.values.tax = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "24%",
      "display": "inline-block"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.currency),
      expression: "taskDialog.values.currency"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taskDialog.values.currency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("CAD")]), _vm._v(" "), _c('option', [_vm._v("USD")])]), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_vm._v("Currency")])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskDialog.values.billed),
      expression: "taskDialog.values.billed"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.taskDialog.values.billed) ? _vm._i(_vm.taskDialog.values.billed, null) > -1 : _vm._q(_vm.taskDialog.values.billed, 1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.taskDialog.values.billed,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.taskDialog.values.billed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.taskDialog.values.billed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.taskDialog.values.billed = $$c
        }
      }
    }
  }), _vm._v("\n\t\t        \t\tTask has been Billed\n\t\t        \t")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.taskDialog.alert.visible) ? _c('div', {
    staticClass: "alert",
    class: _vm.taskDialog.alert.class
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.taskDialog.alert.msg) + "\n\t\t\t"), (_vm.taskDialog.alert.errors) ? _c('ul', _vm._l((_vm.taskDialog.alert.errors), function(error) {
    return _c('li', [_vm._v("\n\t\t\t\t\t" + _vm._s(error) + "\n\t\t\t\t")])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), ('id' in _vm.taskDialog.values) ? _c('button', {
    staticClass: "btn btn-danger pull-left",
    on: {
      "click": function($event) {
        _vm.deleteTask(_vm.taskDialog.values.id)
      }
    },
    slot: "footer"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Delete Task")]) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4db9b5d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskList.vue
// module id = 286
// module chunks = 0